<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'TITLE-ITAU-API-CONFIG' | translate}}</span>
    </p-header>

    <p-card class="card-bg">
        <div class="list-header">
            <span class="section-title">Configurações por carteira de cobrança</span>
            <button class="easymarine primary" (click)="newConfig()" [disabled]="busy">Nova configuração</button>
        </div>
        <p class="hint">
            Sem configuração ativa para a carteira, o boleto em lote do Itaú continua saindo pelo plugin.
        </p>
        <p-table [value]="configs" styleClass="p-datatable-sm" [rowHover]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>Carteira de cobrança</th>
                    <th>Agência / Conta</th>
                    <th>Status</th>
                    <th>Último teste</th>
                    <th>Validade do certificado</th>
                    <th class="text-center">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr [class.row-selected]="form && form.id != null && form.id === row.id">
                    <td>{{portfolioLabel(row)}}</td>
                    <td>{{row.branchNumber}} / {{row.accountNumber}}<span *ngIf="row.accountNumberVd">-{{row.accountNumberVd}}</span></td>
                    <td>
                        <span class="status-badge" [ngClass]="row.active ? 'status-on' : 'status-off'">
                            {{row.active ? 'Ativo' : 'Inativo'}}
                        </span>
                    </td>
                    <td>
                        <ng-container *ngIf="row.lastTestAt || row.lastTestOk != null; else neverTested">
                            <i class="pi" [ngClass]="row.lastTestOk ? 'pi-check text-ok' : 'pi-times text-fail'"></i>
                            {{row.lastTestOk ? 'OK' : 'Falhou'}}
                            <span *ngIf="toDate(row.lastTestAt) as testedAt">em {{testedAt | date:'dd/MM/yyyy HH:mm'}}</span>
                        </ng-container>
                        <ng-template #neverTested><span class="text-muted">Nunca testado</span></ng-template>
                    </td>
                    <td>
                        <ng-container *ngIf="certStatus(row) as cert">
                            <span *ngIf="cert.state === 'none'" class="text-muted">Sem certificado</span>
                            <span *ngIf="cert.state !== 'none'" [ngClass]="'cert-' + cert.state">
                                {{cert.validUntil | date:'dd/MM/yyyy'}}
                                <span *ngIf="cert.state === 'expired'">(vencido)</span>
                                <span *ngIf="cert.state !== 'expired'">({{cert.daysLeft}} dias)</span>
                            </span>
                        </ng-container>
                    </td>
                    <td class="text-center">
                        <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text"
                                pTooltip="Editar" tooltipPosition="left" [disabled]="busy" (click)="openConfig(row)"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-muted">Nenhuma configuração cadastrada.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-card>

    <p-card *ngIf="form" class="card-bg">
        <div class="list-header">
            <span class="section-title">
                {{isNew ? 'Nova configuração' : 'Configuração da carteira ' + portfolioLabel(form)}}
            </span>
            <span *ngIf="!isNew" class="status-badge" [ngClass]="form.active ? 'status-on' : 'status-off'">
                {{form.active ? 'Ativo' : 'Inativo'}}
            </span>
        </div>

        <div class="block-title">Vínculo com o ERP</div>
        <div class="row row-div">
            <div class="form-control mr-4">
                <label class="mr-2 mb-1">Carteira de Cobrança</label>
                <p-dropdown [(ngModel)]="form.billingPortfolioId" appendTo="body"
                            [placeholder]="'Selecione...'"
                            [options]="billingPortfolioOptions"
                            [disabled]="!isNew"
                            [filter]="true">
                </p-dropdown>
            </div>
            <div class="form-control mr-4">
                <label class="mr-2 mb-1">Forma de Pagamento</label>
                <p-dropdown [(ngModel)]="form.paymentMethod" appendTo="body"
                            [placeholder]="'Selecione...'"
                            [options]="paymentMethodsDropdown"
                            (onChange)="selectedPaymentMethods($event.value)">
                </p-dropdown>
            </div>
            <div class="form-control mr-4">
                <label class="mr-2 mb-1">Forma de Pagamento Pix</label>
                <p-dropdown [(ngModel)]="form.paymentMethodPix" appendTo="body"
                            [placeholder]="'Selecione...'"
                            [options]="paymentMethodsPixDropdown"
                            [showClear]="true">
                </p-dropdown>
            </div>
            <div class="form-control mr-4">
                <label class="mr-2 mb-1">Conta para Crédito</label>
                <p-dropdown [(ngModel)]="form.account" appendTo="body"
                            [placeholder]="accountDropdown.length ? 'Selecione...' : 'Escolha a forma de pagamento'"
                            [disabled]="accountDropdown.length === 0"
                            [options]="accountDropdown">
                </p-dropdown>
            </div>
        </div>

        <div class="block-title">Dados da conta no Itaú</div>
        <div class="row row-div">
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwBranchNumber">Agência</label></div>
                <input pInputText id="gwBranchNumber" name="gwBranchNumber" type="text" class="input-sm"
                       [(ngModel)]="form.branchNumber">
            </div>
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwAccountNumber">Conta</label></div>
                <input pInputText id="gwAccountNumber" name="gwAccountNumber" type="text" class="input-sm"
                       [(ngModel)]="form.accountNumber">
            </div>
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwAccountNumberVd">DV</label></div>
                <input pInputText id="gwAccountNumberVd" name="gwAccountNumberVd" type="text" class="input-xs"
                       [(ngModel)]="form.accountNumberVd">
            </div>
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwWallet">Carteira</label></div>
                <input pInputText id="gwWallet" name="gwWallet" type="text" class="input-xs"
                       [(ngModel)]="form.wallet">
            </div>
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwPixKey">Chave Pix</label></div>
                <input pInputText id="gwPixKey" name="gwPixKey" type="text"
                       [(ngModel)]="form.pixKey">
            </div>
        </div>
        <div class="row row-div mt-3">
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwBeneficiaryDocument">CNPJ do cedente</label></div>
                <input pInputText id="gwBeneficiaryDocument" name="gwBeneficiaryDocument" type="text"
                       mask="00.000.000/0000-00"
                       [(ngModel)]="form.beneficiaryDocument">
            </div>
            <div class="form-control mr-4">
                <div class="mb-1"><label for="gwBeneficiaryName">Nome do cedente</label></div>
                <input pInputText id="gwBeneficiaryName" name="gwBeneficiaryName" type="text" class="input-lg"
                       [(ngModel)]="form.beneficiaryName">
            </div>
            <div class="form-control mr-4 checkbox-field">
                <p-checkbox [(ngModel)]="form.sendFineInterest" [binary]="true" inputId="gwSendFineInterest"
                            label="Repassar multa, juros e desconto ao banco"></p-checkbox>
            </div>
        </div>

        <div class="block-title">Certificado</div>
        <div class="cert-box">
            <div class="row row-div">
                <div class="form-control mr-4">
                    <div class="mb-1"><label for="gwItauClientId">Client ID</label></div>
                    <input pInputText id="gwItauClientId" name="gwItauClientId" type="text" class="input-lg"
                           autocomplete="off" [(ngModel)]="clientIdInput">
                </div>
                <div class="form-control mr-4">
                    <div class="mb-1"><label for="gwTokenTemporario">Token temporário</label></div>
                    <input pInputText id="gwTokenTemporario" name="gwTokenTemporario" type="password" class="input-lg"
                           autocomplete="off" [(ngModel)]="tokenTemporario">
                </div>
                <div class="form-control mr-4">
                    <button class="easymarine primary" [disabled]="!canGenerateCertificate"
                            (click)="generateCertificate()">Gerar certificado no gateway</button>
                </div>
            </div>
            <p *ngIf="isNew" class="hint">Salve a configuração antes de gerar o certificado.</p>
            <div class="row row-div mt-2">
                <div class="form-control mr-4">
                    <span class="info-label">Titular:</span>
                    <span>{{form.certHolder || '—'}}</span>
                </div>
                <div class="form-control mr-4">
                    <span class="info-label">Validade:</span>
                    <ng-container *ngIf="certStatus(form) as cert">
                        <span *ngIf="cert.state === 'none'" class="text-muted">Sem certificado</span>
                        <span *ngIf="cert.state !== 'none'" [ngClass]="'cert-' + cert.state">
                            {{cert.validUntil | date:'dd/MM/yyyy'}}
                            <span *ngIf="cert.state === 'expired'">(vencido)</span>
                            <span *ngIf="cert.state === 'expiring'">(vence em {{cert.daysLeft}} dias)</span>
                            <span *ngIf="cert.state === 'valid'">({{cert.daysLeft}} dias)</span>
                        </span>
                    </ng-container>
                </div>
            </div>
            <div class="alert-warning cert-warning">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                Gerar um novo certificado invalida o secret anterior deste Client ID.
            </div>
        </div>

        <div class="block-title">Status</div>
        <div class="row row-div status-row">
            <div class="form-control mr-4">
                <span class="info-label">Situação:</span>
                <span class="status-badge" [ngClass]="form.active ? 'status-on' : 'status-off'">
                    {{form.active ? 'Ativo' : 'Inativo'}}
                </span>
            </div>
            <div class="form-control mr-4">
                <span class="info-label">Último teste:</span>
                <ng-container *ngIf="form.lastTestAt || form.lastTestOk != null; else formNeverTested">
                    <i class="pi" [ngClass]="form.lastTestOk ? 'pi-check text-ok' : 'pi-times text-fail'"></i>
                    {{form.lastTestOk ? 'OK' : 'Falhou'}}
                    <span *ngIf="toDate(form.lastTestAt) as testedAt">em {{testedAt | date:'dd/MM/yyyy HH:mm'}}</span>
                    <span *ngIf="form.lastTestDetail" class="text-muted"> — {{form.lastTestDetail}}</span>
                </ng-container>
                <ng-template #formNeverTested><span class="text-muted">Nunca testado</span></ng-template>
            </div>
            <div class="form-control mr-4" *ngIf="!isNew">
                <span class="info-label">Aviso de pagamento no Itaú:</span>
                <span>{{form.bankPaymentNoticeRegistered ? 'Registrado' : 'Pendente'}}</span>
            </div>
        </div>
        <ul *ngIf="!form.active && activationBlockers.length > 0" class="blockers">
            <li *ngFor="let blocker of activationBlockers">{{blocker}}</li>
        </ul>

        <div class="text-right mt-4 mr-3 actions">
            <button class="easymarine secondary" [disabled]="busy" (click)="cancelEdit()">Fechar</button>
            <button class="easymarine primary" [disabled]="busy" (click)="save()">Salvar</button>
            <button class="easymarine primary" [disabled]="!canTest" (click)="testConnection()">Testar conexão</button>
            <button class="easymarine success" [disabled]="!canActivate" (click)="activate()">Ativar</button>
            <button class="easymarine danger" [disabled]="!canDeactivate" (click)="deactivate()">Desativar</button>
        </div>
    </p-card>
</p-fieldset>
